import(/* webpackMode: "eager" */ "C:\\Users\\e.alseddiq\\Projects\\FintekWebsite\\app\\services\\payment-solutions\\page.tsx")